<template>
    <div>
        <div class="modal-overlay active"  @click="closeDialog()"></div>
        <div class="modal">
            <div class="modal__header">
                <h2 class="headline-s">California Prop 65 Warning</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="modal__body">
                <WarningIcon class="modal__icon" width="32" alt="Warning" />
                <div class="modal__body--content-wrapper">
                    <p><strong>WARNING:</strong> This product can expose you to <strong>{{ prop65Spec[0] }}</strong> which is known to the State of California to cause cancer and birth defects or other reproductive harm.</p>
                    <a style="word-break: break-all;" href="https://www.p65warnings.ca.gov/" target="_blank" rel="noopener noreferrer">https://www.p65warnings.ca.gov/</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

    import { inject } from "vue";
    const dialogRef = inject('dialogRef');
    import CloseIcon from "@icons/closeIcon.svg";
    import WarningIcon from "@icons/warning-icon.svg";
    const prop65Spec = dialogRef?.value?.data?.prop65Spec ?? [];

    const closeDialog = () => {
        dialogRef?.value?.close();
    }
</script>

<style scoped>
    .modal__icon {
        transform: scale(2);
    }
</style>